import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const PopUpBox = styled(FocusNode)`
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  width: 1920px;
  height: 1080px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 13;
`

export const PopUpElem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: auto;
  min-width: 30%;
  max-width: 60%;
  height: auto;
  min-height: 30%;
  background: linear-gradient(
    108deg,
    ${(props) => props.theme.colors.dialogPopup.background.start} 0%,
    ${(props) => props.theme.colors.dialogPopup.background.end} 100%
  );
  padding: 40px;
  border: 4px solid rgba(255, 255, 255, 0.15);
  border-radius: 24px;
  overflow: hidden;
`
export const Title = styled.h2`
  width: 100%;
  font-size: 40px;
  line-height: 1.2;
  color: #ffffff;
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 24px;
  text-align: center;
`
export const Description = styled.p`
  width: 100%;
  font-size: 20px;
  line-height: 1.5;
  white-space: pre-line;
  padding-bottom: 65px;
  max-width: 1000px;
  margin: 0 auto;
`
export const ActionsWrapper = styled.div`
  min-height: 80px;
  width: 100%;
  position: relative;
`
export const Actions = styled.div`
  display: flex;
  align-self: flex-end;
  justify-content: space-evenly;
  width: 100%;

  & > :last-child {
    margin-left: 50px;
  }
`
